import React, {useState, useEffect} from 'react';
import Student from '../../models/Student';
import StudentForm from '../../forms/StudentForm';
import UserService from '../../services/UserService';
import {useUI, usePageUI} from '../../app/context/ui';
import { connect } from 'react-redux';

const EditPage = (props) => {
  const {alertUI} = usePageUI();
  const {blockUI} = useUI();
  const [isValid, setIsValid] = useState(false);
  const [data, setData] = useState(Student);

  useEffect(() => {
    UserService.init(props.user.accessToken, props.campus.id);
  }, [props.campus]);

  useEffect(() => {
    setData(props.studentData)
  }, [props.studentData]);

  const saveStudent = async (student) => {
    blockUI.current.open(true, 'Estamos guardando...');
    try {
      const response = await UserService.update(student, student.id);
      if (response) {
        blockUI.current.open(false);
        alertUI.current.open(true, response.data.message, 'success');
        props.changeTab(1);
        setIsValid(true);
      }
    } catch (error) {
      blockUI.current.open(false);
      //alertUI.current.open(true, Object.values(error.response.data.errors)[0], 'danger');
      alertUI.current.open(true, 'Error', 'danger');
    }
  }
  const searchAgent = val => {
    props.searchAgent(val);
    setIsValid(false);
  }

  return(
    <>
      <StudentForm
        studentData = {data}
        agents={props.agents}
        searchAgent={searchAgent}
        saveStudent={saveStudent}
        isValid={isValid}
      />
    </>
  );
}

const mapStateToProps = state => {
  return {
    user: state.user,
    campus: state.campus
  };
};

export default connect(mapStateToProps)(EditPage);